export default {
    computed: {

        
    },
    watch: {

    },
    methods: {
        getCustomEntityId(value, entityList, entityFieldName, entityName) {
            const entity = entityList.find(x => x[entityFieldName] == value)
            if (entity == null && ['Order Item Type', 'Secondary Type'].find(x => x == entityName) !== true)
                throw new Error(`${entityName}:${value} does not exist.`)
            return entity?.id || null
        },
    },
}
